<template>
  <div class="d-flex flex-column pa-3" style="gap: 10px;">
    <a-pricing-strategy-rule-type-condition-field-slider
      :value="cond.settings.condition_rn"
      :label="isNegative ? $t('rn_cancel_more_than') : $t('rn_enter_more_than')"
      :min="schemaMin('condition_rn')"
      :max="schemaMax('condition_rn')"
      :color="isNegative ? 'red' : 'green'"
      :invert="isNegative"
      unit="RN"
      @input="cond.settings.condition_rn = $event"
    />
    <a-pricing-strategy-rule-type-condition-field-select
      :value="cond.settings.condition_spot"
      :label="$t('spot_period_filter')"
      :items="spotItems"
      @input="cond.settings.condition_spot = $event"
    />
  </div>
</template>

<script>
import aPricingStrategyRuleTypeConditionFieldSelect from "./fields/aPricingStrategyRuleTypeConditionFieldSelect.vue";
import aPricingStrategyRuleTypeConditionFieldSlider from "./fields/aPricingStrategyRuleTypeConditionFieldSlider.vue";

export default {
  name: "a-pricing-strategy-rule-type-condition-body-pickup-roomnights",
  components: {
    aPricingStrategyRuleTypeConditionFieldSlider,
    aPricingStrategyRuleTypeConditionFieldSelect
  },

  props: {
    cond: { type: Object, required: true },
    ruleType: { type: Object, required: true }
  },

  computed: {
    isNegative() {
      return this.cond.rule_type_code.indexOf("negative") > -1;
    },
    spotItems() {
      const schema = this.ruleType.settings_schema || {};
      const spotRules = schema.condition_spot || [];
      const inRule = spotRules.find(r => r && r.in);
      if (inRule && inRule.in) {
        return inRule.in.map(v => ({
          text: this.pickupLabel(v),
          value: v
        }));
      }
      // Schema fallback: build pickup-0..pickup-6
      const out = [{ text: this.$t("pickup_0") || "OTB", value: "pickup-0" }];
      for (let i = 1; i <= 6; i++) {
        out.push({
          text: this.pickupLabel("pickup-" + i),
          value: "pickup-" + i
        });
      }
      return out;
    }
  },

  methods: {
    schemaField(field) {
      return (this.ruleType.settings_schema || {})[field] || [];
    },
    schemaMin(field) {
      const r = this.schemaField(field).find(
        r => r && typeof r === "object" && "min" in r
      );
      return r ? r.min : 0;
    },
    schemaMax(field) {
      const r = this.schemaField(field).find(
        r => r && typeof r === "object" && "max" in r
      );
      return r ? r.max : 100;
    },
    // Migrated from the old aPricingStrategyRuleTypeForm-pickup-roomnights.vue
    pickupLabel(spot) {
      if (spot && spot.startsWith("pickup-")) {
        const number = spot.split("-")[1];
        if (number === "0") return this.$t("pickup_0") || "OTB";
        try {
          const hotel =
            this.$store &&
            this.$store.getters &&
            this.$store.getters.current_hotel;
          if (hotel && hotel.settings && hotel.settings.pickup_spots) {
            const label = hotel.settings.pickup_spots["pickup_" + number];
            if (label) return this.$t("pickup") + " " + label;
          }
        } catch (e) {
          /* noop */
        }
        return this.$t("pickup") + " " + number;
      }
      return spot ? spot.replace("-", " ") : spot;
    }
  }
};
</script>
